import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRoller: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="roller, scooter"><circle cx="5.5" cy="16.5" r="2.75" stroke="currentColor" strokeWidth="1.5"/><circle cx="18.5" cy="16.5" r="2.75" stroke="currentColor" strokeWidth="1.5"/><path d="M13.75 4.75H16L18 13.5625" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.5 16.5H15.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconRoller;
